
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon icon--close",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M38.5 39.5c-.3 0-.5-.1-.7-.3L.8 2.3C.4 1.9.4 1.2.8.8S1.9.4 2.3.8l36.9 36.9c.4.4.4 1.1 0 1.5-.2.2-.5.3-.7.3z"}}),_c('path',{attrs:{"d":"M1.5 39.5c-.3 0-.5-.1-.7-.3-.4-.4-.4-1.1 0-1.5L37.7.8c.4-.4 1.1-.4 1.5 0s.4 1.1 0 1.5L2.3 39.2c-.2.2-.5.3-.8.3z"}})])
          )
        }
      }
    